"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
var _variables = require("./variables");
var _shared = require("./shared");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var buttonStyles = {
  button: {
    appearance: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'inherit',
    color: 'inherit',
    padding: '5px',
    border: 'none',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:disabled': {
      backgroundColor: "".concat(_variables.disabledBackground, " !important"),
      color: "".concat(_variables.disabledColour, " !important"),
      cursor: 'default'
    }
  },
  button_standard: {
    minWidth: '100px',
    minHeight: '25px',
    textDecoration: 'none'
  },
  button_link: {
    textDecoration: 'underline',
    color: _variables.anchorColour,
    '&:focus': {
      color: _variables.anchorColour
    },
    '&:active': {
      color: _variables.anchorColour
    },
    '&:hover': {
      color: _variables.anchorColourHover
    }
  },
  button_icon: {
    flex: '0 1 0%',
    padding: '3px 6px',
    margin: '2px 5px',
    textDecoration: 'none',
    '&::before': _objectSpread(_objectSpread({}, _shared.centerContents), {}, {
      content: 'attr(icon)',
      fontSize: '1.5rem'
    }),
    '&:not(:disabled)': {
      cursor: 'pointer'
    }
  },
  button_small: {
    '&::before': {
      fontSize: '0.8rem'
    }
  }
};
var _default = exports["default"] = (0, _nano.sheet)(buttonStyles);